(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.lumino-product-layout').forEach(product => {
      if (product.purchasePanelController) return;
      const controller = new AbortController();
      product.purchasePanelController = controller;
      const { signal } = controller;
      document.addEventListener('pointerdown', event => {
        product.querySelectorAll('.lumino-product-share[open]').forEach(share => {
          if (!share.contains(event.target)) share.open = false;
        });
      }, { signal });
      product.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const share = event.target.closest('.lumino-product-share[open]');
        if (!share) return;
        event.preventDefault(); event.stopPropagation();
        share.open = false;
        share.querySelector('summary').focus();
      }, { signal });
      product.addEventListener('click', event => {
        const link = event.target.closest('[data-lumino-delivery-link]');
        const target = link && document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        link.closest('dialog[open]')?.close();
        requestAnimationFrame(() => {
          const title = target.querySelector('[data-js-title]');
          if (title?.getAttribute('aria-expanded') === 'false') title.click();
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          title?.focus({ preventScroll: true });
        });
      }, { signal });
      let header;
      const experience = product.closest('[data-lumino-experience]');
      const nav = experience?.querySelector('[data-lumino-product-nav]');
      const update = () => {
        const height = header?.classList.contains('show') ? header.getBoundingClientRect().height : 0;
        const navHeight = nav?.getBoundingClientRect().height || 0;
        const top = Math.ceil(height + navHeight) + 18;
        product.style.setProperty('--lumino-purchase-top', `${top}px`);
        experience?.style.setProperty('--lumino-section-offset', `${top + 12}px`);
        experience?.style.setProperty('--lumino-nav-top', `${Math.ceil(height)}px`);
      };
      const resize = new ResizeObserver(update);
      const mutations = new MutationObserver(update);
      if (nav) resize.observe(nav);
      const attachHeader = () => {
        const next = document.querySelector('.sticky-header');
        if (header !== next) {
          if (header) resize.unobserve(header);
          mutations.disconnect();
          header = next;
          if (header) {
            resize.observe(header);
            mutations.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
          }
        }
        update();
      };
      const headerMount = new MutationObserver(attachHeader);
      headerMount.observe(document.body, { childList: true });
      window.addEventListener('resize', update, { signal: controller.signal, passive: true });
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(product)) return;
        controller.abort(); resize.disconnect(); mutations.disconnect(); headerMount.disconnect();
      }, { signal: controller.signal });
      attachHeader();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

